import { render } from "./SetsList.vue?vue&type=template&id=15605908"
import script from "./SetsList.vue?vue&type=script&lang=js"
export * from "./SetsList.vue?vue&type=script&lang=js"

import "./SetsList.vue?vue&type=style&index=0&id=15605908&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__